export const ERROR_MATCHES = 'ERROR_MATCHES'
export const ERROR_ORDERS = 'ERROR_ORDERS'
export const ERROR_RESULTS = 'ERROR_RESULTS'
